import React from 'react'
import {useOptionValues, useFormFieldAttributes} from "../../utils"
import FlaveRadioButton from "./raw_fields/flave_radio_button";

const RadioButton = ({tagOwner, formMode, field}) => {
  const optionValues = useOptionValues(formMode, field)
  const {
    fieldName,
    title,
    fieldMode,
    placeholder,
    hint,
    errorMessage,
    prefill,
  } = useFormFieldAttributes(formMode, field);
  // console.log("RENDERING RADIO")

  const options = optionValues.map(option => {
    return {
      label: option[1],
      value: option[0]
    }
  })

  return <FlaveRadioButton
    name={fieldName}
    label={title || field}
    options={options}
    readOnly={fieldMode == "readonly"}
    defaultValue={prefill ? tagOwner  && tagOwner[field] : ""}
    placeholder={placeholder}
    hint={hint}
    errorMessage={errorMessage}
  />
}

export default RadioButton;
